
import { mapGetters } from 'vuex'
import dataTable from '@/mixins/dataTable'
import playerProfile from '~/mixins/common/pages/player-profile'
export default {
    mixins: [dataTable, playerProfile],
    data() {
        return {
            tab: null,
            tabModel: 1,
            api: 'themes/refer-friend/getReferFriend',
            page: 1,
            modal: false,
            minHeight: 900,
            claimLoading: false,
            sortBy: '',
        }
    },
    computed: {
        ...mapGetters({
            referFriend: 'themes/refer-friend/referFriend',
            friendList: 'themes/refer-friend/friendList',
        }),
    },
    mounted() {
        if (window) {
            this.minHeight = window.innerHeight - 130
        }
        this.customFilters = {
            language: this.handleCookie('wl_locale'),
            start_date: this.$dayjs().format('YYYY-MM-DD'),
            end_date: this.$dayjs().format('YYYY-MM-DD'),
        }
        if (this.referFriend?.data?.length) return
        this.API()
        this.$store.dispatch('themes/refer-friend/friendList', {
            ...this.customFilters,
        })
    },
    beforeDestroy() {
        this.doCancelAxiosRequest()
    },
    methods: {
        doSubmitSearch() {
            this.API()
            this.$store.dispatch(
                'themes/refer-friend/friendList',
                this.customFilters
            )
        },
        async claimCommission() {
            if (!this.referFriend.is_claimable) return
            this.claimLoading = true
            const result = await this.$store.dispatch(
                'themes/refer-friend/doClaimCommission'
            )
            if (result) {
                await this.$store.dispatch('player/profile')
                this.API()
            }
            this.claimLoading = false
        },
        changePage() {
            if (this.customFilters.page !== this.page) {
                this.customFilters.page = this.page
                this.API()
            }
        },
        updateStartDate(date) {
            this.customFilters.start_date = date
        },
        updateEndDate(date) {
            this.customFilters.end_date = date
        },
    },
}
